import React, {
  createContext,
  PropsWithChildren,
  useContext,
  useMemo,
} from 'react';

type ContextValues = {
  patientId: number;
  isCurrentNoteFinalized: boolean;
};

export const PastNotesContext = createContext<ContextValues>({
  patientId: 0,
  isCurrentNoteFinalized: false,
});

export function usePastNotesContext(): ContextValues {
  return useContext(PastNotesContext);
}

type Props = PropsWithChildren<ContextValues>;

export default function PastNotesProvider({
  children,
  patientId,
  isCurrentNoteFinalized,
}: Props) {
  const value = useMemo(() => ({
    patientId,
    isCurrentNoteFinalized,
  }), [patientId, isCurrentNoteFinalized]);

  return (
    <PastNotesContext.Provider value={value}>
      {children}
    </PastNotesContext.Provider>
  );
}
